export default "__VITE_ASSET__a5229c49__"